"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/DirectoryCreateNewModal/CreateNewPatient.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _upgrade = require('shared/enum/upgrade');
var _contact = require('shared/enum/contact');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _session = require('shared/selectors/session');



var _org = require('shared/selectors/org');
var _myRelations = require('shared/selectors/myRelations');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _Forms = require('web/screens/Directory/Forms');

var _useOrgPatientTags = require('./useOrgPatientTags'); var _useOrgPatientTags2 = _interopRequireDefault(_useOrgPatientTags);






const CreateNewPatient = ({ orgKeyContext, onClose }) => {
  const orgKeyInView = _hooks.useAppSelector.call(void 0, state => orgKeyContext || _session.selectSelectedOrgKey.call(void 0, state))
  // Without a texting number the org in view isn't assumed; the user picks.
  const mustChooseOrg = _hooks.useAppSelector.call(void 0, 
    state => !!orgKeyInView && !_myRelations.selectDoIHavePhoneTeamInOrg.call(void 0, state, orgKeyInView),
  )
  const patientMessagingOrgs = _hooks.useAppSelector.call(void 0, 
    state => _org.selectPatientMessagingOrgs.call(void 0, state, _contact.CONTACT_REL_TYPES.PATIENT),
  )
  // With a single choice there is nothing to ask; it's picked but stays visible.
  const [chosenOrgKey, setChosenOrgKey] = _react.useState(
    patientMessagingOrgs.length === 1 ? patientMessagingOrgs[0].OrgKey : '',
  )
  const orgKey = mustChooseOrg ? chosenOrgKey || null : orgKeyInView
  const hasFeature = _hooks.useAppSelector.call(void 0, 
    state => !!orgKey && _org.selectOrgHasPatientMessagingFeature.call(void 0, state, orgKey),
  )
  const {
    isOpen: isUpsellModalOpen,
    onOpen: onOpenUpsellModal,
    onClose: onCloseUpsellModal,
  } = _useToggle2.default.call(void 0, )

  const orgTags = _useOrgPatientTags2.default.call(void 0, orgKey)

  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onSubmit = _react.useCallback.call(void 0, 
    async ({ firstName, lastName, dob, email, phone, foreignID }, tagValue) =>
      orgKey &&
      _actions2.default.createPatient({
        OrgKey: orgKey,
        FirstName: firstName,
        LastName: lastName,
        DateOfBirth: dob,
        Email: email,
        Phone: phone,
        ForeignID: foreignID,
        TagKeys: tagValue.TagKeys,
        NewTagNames: tagValue.NewNames,
      })
        .then(({ Patients }) => {
          const [patientKey] = Object.keys(Patients) 
          if (!patientKey) return
          _actions2.default.gotoPatientPage(orgKey, patientKey)
          onClose()
        })
        .catch((e) => {
          let msg = 'Failed to create patient'
          if (e.extra && e.extra.Error) {
            msg += ': ' + e.extra.Error
          }
          showWarningBar(msg)
        }),
    [orgKey, onClose, showWarningBar],
  )

  return (
    _react2.default.createElement('div', { className: "directory--create-new--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
      ,  !mustChooseOrg && orgKey && !hasFeature && (
        _react2.default.createElement(_WarningBar2.default, {
          className: "directory--create-new--warning",
          text: "Want to get access to SMS Messaging?"      ,
          linkText: "Request access" ,
          onLinkClick: onOpenUpsellModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
        )
      )
      ,  !orgKeyInView && (
        _react2.default.createElement(_WarningBar2.default, {
          className: "directory--create-new--warning",
          text: "You need to join an organization to invite patients."        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
        )
      )
      , _react2.default.createElement(_Forms.PatientForm, {
        onSubmit: onSubmit,
        onCancel: onClose,
        isDisabled: !mustChooseOrg && !hasFeature,
        isSubmitDisabled: !orgKey,
        hideOrgNotice: mustChooseOrg,
        beforeControls: mustChooseOrg && (
          _react2.default.createElement(_Forms.PatientOrgChoice, {
            orgs: patientMessagingOrgs,
            value: chosenOrgKey,
            onChange: setChosenOrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
          )
        ),
        orgKeyContext: orgKey,
        tags: orgTags,
        submitBtnLabel: "Add",
        controlsClassName: "invite-contact--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
      )
      ,  orgKey && (
        _react2.default.createElement(_UpgradeModal2.default, {
          orgKey: orgKey,
          type: _upgrade.SubscriptionItemType.SMS,
          isOpen: isUpsellModalOpen,
          onClose: onCloseUpsellModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, CreateNewPatient)
